module.exports = __webpack_public_path__ + "static/media/H_8.68ed3180.png";